import { HTTP } from "./http";

let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER =
    "http://www.localhost:8888/back-end-endpoint-platform-billing.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-platform-billing.php";
}

// The club's subscription to the platform (£1/player·mo, AU A$2). The endpoint
// resolves the club from the tenant config, so most calls need no clubId.
const PlatformBilling = {
  // Current subscription status + live count/fee.
  getStatus() {
    return HTTP.post(API_SERVER, { action: "getBillingStatus" });
  },
  // Read-only preview of the current bill.
  getSummary() {
    return HTTP.post(API_SERVER, { action: "getBillableSummary" });
  },
  // Start Stripe Checkout (subscription) — returns { url } to redirect to.
  createCheckout(email) {
    return HTTP.post(API_SERVER, { action: "createBillingCheckout", email });
  },
  // Stripe billing-portal link (manage card / invoices).
  createPortal() {
    return HTTP.post(API_SERVER, { action: "createPortalSession" });
  },
};

export { PlatformBilling };
